import styled from 'styled-components';

const SocialWrapper = styled.div<{ color?: string }>`
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  width: 100%;
  height: 54px;
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.primary900};
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: ${({ theme }) => theme.colors.primary900};
    margin-left: 15px;
  }
  @media (max-width: 260px) {
    font-size: 12px;
  }
`;

interface SocialButtonType {
  text: string;
  color?: string;
  icon: any;
  onHandleLogin: any;
}

export const SocialButton = ({
  text,
  color,
  icon,
  onHandleLogin
}: SocialButtonType) => (
  <SocialWrapper color={color} onClick={onHandleLogin}>
    <img src={icon} alt='' />
    <p>{text}</p>
  </SocialWrapper>
);
